import type { SearchValues } from "../types";

export const searchValues: SearchValues = {
  toDate: "",
  fromDate: "",
  customerName: "",
  customerPhone: "",
  giftSenderName: "",
  giftProjectName: "",
  giftReceiverName: "",
  giftReceiverPhone: "",
  giftProjectOrderItemDesignStatus: "",
};

export const excelHeaderCellsName: Record<string, string> = {
  المبلغ: "amount",
  "رقم الطلب": "orderId",
  "التاريخ ": "createdOn",
  "رقم العنصر": "orderItemId",
  "اسم المتبرع": "customerName",
  "وسيلة التبرع": "paymentType",
  "المشروع ": "giftProjectName",
  "اسم المرسل ": "giftSenderName",
  "رابط الإهداء": "giftProjectLink",
  "رقم هاتف المتبرع": "customerPhone",
  "إسم المهدي إليه": "giftRecieverName",
  "هاتف المهدي إليه": "giftRecieverPhone",
};
